import React, { ReactNode, useEffect, useState } from "react"
import { AdminIcons } from "../Shared/AdminIcon"
import { ScreenHeader } from "../UI/Elements"
import { CustomColumnContainer, ThreeColumnContainer } from "../Shared/Formelements";
import { useOrganizations } from "../Organizations/useOrganizations";
import { OrganizationModelType } from "../../rdx/organizationReducer";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { MessageBoxes } from "../../Handlers/MessageBoxes";

export const GamificationAds = () => {
    const ui = useGamificationAds();

    useEffect(() => {
        ui.load();
        ui.loadOrgs("");
    }, [])



    return (
        <div className="gamification-ads">
            <ScreenHeader text="Gamification annons" icon={AdminIcons.ad} />
            <h3>
                Annonser
            </h3>
            <div>
                <button className="btn" onClick={ui.addNew}>
                    Ny
                </button>
            </div>
            <hr />
            <div className="adlist">

                {ui.data?.map(c => (
                    <Editor
                        key={c?.id}
                        c={c}
                        orgs={ui.orgs}
                        onChange={ui.onChange}
                        onSave={ui.onSave}
                        onDelete={ui.onDelete}
                        unsavedChanges={!!ui.unsavedChanges?.[c?.id]}
                    />
                ))}

            </div>

        </div>
    )
}

const Editor = ({ c, orgs, onChange, onSave, onDelete, unsavedChanges }: { c: GamificationAdType, orgs: OrganizationModelType[], onSave(e: GamificationAdType): void, onChange(e: GamificationAdType): void, onDelete(e: string): void, unsavedChanges: boolean }) => {
    const [editing, setEditing] = useState<boolean>(!c?.id);
    const m = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const y = [
        new Date().getFullYear() - 1, new Date().getFullYear(),
        new Date().getFullYear() + 1, new Date().getFullYear() + 2,
        new Date().getFullYear() + 3, new Date().getFullYear() + 4,
        new Date().getFullYear() + 5, new Date().getFullYear() + 6
    ];


    return (
        <div key={c?.id} className={"ad" + (unsavedChanges ? " unsaved " : "")}>

            <div>
                <h4>Annons {c?.year}-{c?.month}</h4>
                <TextEditor label={"Rubrik"} value={c?.header} editing={editing} onChange={e => { onChange({ ...c, header: e as string }) }} />
                <TextEditor label={"Ttext"} value={c?.text} editing={editing} onChange={e => { onChange({ ...c, text: e as string }) }} />
                <TextEditor label={"Totalpoints"} value={c?.totalpoints} type="number" editing={editing} onChange={e => { onChange({ ...c, totalpoints: e as number }) }} />
                <CustomEditor label="År-Månad"
                    editing={editing}
                    viewElement={(<span>{c?.year}-{c?.month}</span>)}
                    editingElement={(<span>
                        <select defaultValue={c?.year} onChange={e => { onChange({ ...c, year: parseInt(e.target.value) }) }}>
                            {y.map(n => (<option value={n}>{n}</option>))}
                        </select>-
                        <select defaultValue={c?.month} onChange={e => { onChange({ ...c, month: parseInt(e.target.value) }) }}>
                            {m.map(n => (<option value={n}>{n}</option>))}
                        </select>
                    </span>)}
                />
                <CustomEditor
                    label="Organisation"
                    editing={editing}
                    viewElement={(<div>{orgs.find(m => m?.id === c?.organizationid)?.name}</div>)}
                    editingElement={(<select defaultValue={c?.organizationid} onChange={e => { onChange({ ...c, organizationid: e.target.value }) }}>
                        {orgs?.map(o => (
                            <option value={o?.id}>{o?.name}</option>
                        ))}
                    </select>)}
                />
                <ImageEditor
                    refId={c?.id}
                    label={"Image"}
                    imageId={c?.imageid}
                    imageUrl={c?.imageurl}
                    onChange={e => { onChange({ ...c, imageid: e }) }}
                    editing={editing} />


            </div>
            <div>
                <h4>Splash</h4>
                <TextEditor label={"Splash rubrik"} value={c?.splashheader} editing={editing} onChange={e => { onChange({ ...c, splashheader: e as string }) }} />
                <TextEditor label={"Splash text"} value={c?.splashtext} type="multiline" editing={editing} onChange={e => { onChange({ ...c, splashtext: e as string }) }} />
            </div>
            <div>
                <h4>Reward</h4>
                <TextEditor label={"Reward header"} value={c?.rewardheader} editing={editing} onChange={e => { onChange({ ...c, rewardheader: e as string }) }} />
                <TextEditor label={"Reward text"} value={c?.rewardtext} type="multiline" editing={editing} onChange={e => { onChange({ ...c, rewardtext: e as string }) }} />
                <TextEditor label={"Reward description"} value={c?.rewarddescription} type="multiline" editing={editing} onChange={e => { onChange({ ...c, rewarddescription: e as string }) }} />
            </div>
            <div>
                <div className="btns">
                    {/* editing */}
                    {!!editing && (
                        <>
                            <button className="btn" onClick={() => setEditing(!editing)}>Ångra</button>
                            <button className="btn last" onClick={() => onDelete(c?.id)}>Radera</button>
                            <button className="btn" onClick={async () => {
                                setEditing(false);
                                await onSave(c);
                            }}>Spara</button>
                        </>
                    )}
                    {/* NOT editing */}
                    {!editing && (
                        <>
                            <button className="btn" onClick={() => setEditing(!editing)}>Ändra</button>
                            <button className="btn last" onClick={() => onDelete(c?.id)}>Radera</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

const TextEditor = ({ label, value, onChange, editing, type = "text" }: { label: string, value: string | number, onChange(e: string | number): void, editing: boolean, type?: "text" | "multiline" | "number" }) => {

    return (
        <div className="prop">
            <div className="lbl">{label}</div>

            {!editing && (
                <div className="val">{value}</div>
            )}
            {!!editing && (
                <div>
                    {type === "text" && (
                        <input type="text" defaultValue={value} onChange={e => onChange(e.target.value)} />
                    )}
                    {type === "number" && (
                        <input type="number" defaultValue={value} onChange={e => onChange(e.target.valueAsNumber)} />
                    )}
                    {type === "multiline" && (
                        <textarea defaultValue={value} onChange={e => onChange(e.target.value)} />
                    )}

                </div>
            )}

        </div>
    )
}
const CustomEditor = ({ label, editing, editingElement, viewElement }: { label: string, editing: boolean, editingElement?: ReactNode, viewElement?: ReactNode }) => {

    return (
        <div className="prop">
            <div className="lbl">{label}</div>
            {!!editing && (<div className="val">{editingElement}</div>)}
            {!editing && (<div className="val">{viewElement}</div>)}

        </div>
    )
}

const ImageEditor = ({ refId, label, imageId, imageUrl, onChange, editing }: { refId: string, label: string, imageId: string, imageUrl: string, onChange(e: string): void, editing: boolean, }) => {

    const [selectedFile, setSelectedFile] = useState<File>(undefined);
    const [previewUrl, setPreviewUrl] = useState<string>(undefined);
    const [errorMsg, setErrorMsg] = useState<string>(undefined);

    const upload = async () => {
        if (!selectedFile) { return }

        setErrorMsg(undefined);
        const url = "/api/gamification/campaign/" + refId + "/image";

        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append("image", selectedFile, selectedFile?.name);

        const resp: { success: boolean, imageid: string } = await FetchHandler.postForm(url, formData) as any;

        console.log("resp:", resp);
        if (resp?.success) {
            onChange(resp.imageid)
        }



    }

    useEffect(() => {
        if (!!selectedFile) {
            upload();
        }
    }, [selectedFile])


    const [imageVersion, setImageVersion] = useState<number>(1)
    const _imageUrl = imageUrl + "?v=" + imageVersion;

    useEffect(() => {
        setImageVersion(new Date().valueOf());
    }, [, imageId, editing])



    if (!refId) {
        return (
            <div className="prop">
                <div className="lbl">{label}</div>
                <div className="val">Du måste spara annonsen innan en bild kan läggas till</div>
            </div>
        )
    }

    return (
        <div className="prop">
            <div className="lbl">{label}</div>

            {/* NOT Editing */}
            {!editing && (
                <div>
                    {!!imageId && (
                        <div className="img-element">
                            <img src={_imageUrl} alt="" />
                        </div>
                    )}
                </div>)}

            {/* Editing */}
            {!!editing && (
                <div className="img-element">
                    <input type="file" onChange={e => {
                        setErrorMsg(undefined);
                        const f = e?.target.files?.[0];
                        const isJpg = f?.name?.toLowerCase()?.endsWith(".jpg") || f?.name?.toLowerCase()?.endsWith(".jpeg");
                        if (f) {
                            if (isJpg) {
                                setSelectedFile(f);
                                setPreviewUrl(URL.createObjectURL(f))
                            } else {
                                setErrorMsg("Bilden måsta vara av typ .JPG.");
                            }
                        }
                    }} />
                    <div>
                        {errorMsg}
                    </div>
                    {!!previewUrl && (<img src={previewUrl} loading="lazy" />)}
                    {(!previewUrl && !!imageId) && (<img src={_imageUrl} loading="lazy" />)}
                </div>
            )}

        </div>
    )
}

const useGamificationAds = () => {
    const api = useGamificationAdsApi();
    const [data, setData] = useState<GamificationAdType[]>([]);
    const [unsavedChanges, setUnsavedChanges] = useState<Record<string, boolean>>({});

    const orgs = useOrganizations();

    const load = async () => {
        const d = await api.getAll();
        setData(d);

    }

    return {
        data: data,
        load: load,
        unsavedChanges: unsavedChanges,
        onChange: async (e: GamificationAdType) => {
            console.log("onChange:", e);
            let d = [...data];
            const i = d.findIndex(m => m.id === e?.id);
            d[i] = e;
            setData(d);
            setUnsavedChanges({ ...unsavedChanges, [e?.id]: true });
        },
        onSave: async (e: GamificationAdType) => {
            console.log("onSave:", e);
            if (e?.id?.length > 12) {
                const d = await api.update(e);
                await load();
            } else {
                const d = await api.add(e);
                await load();
            }
            setUnsavedChanges({ ...unsavedChanges, [e?.id]: false });
        },
        onDelete: async (id: string) => {
            if (MessageBoxes.confirm("Radera?")) {
                if (!!id) {
                    const d = await api.remove(id);
                }
                await load();
            }
        },
        orgs: orgs.data,
        loadOrgs: orgs.doSearch,
        addNew: () => {
            setData([{
                "header": "Vinn med Impecta Fröhandel!",
                "text": "Samla 20 fröer under perioden april-maj, så kommer du belönas med en fröpåse!",
                "imageurl": "https://storageaccohgarden.blob.core.windows.net/ohgardenpublic/tests/impecta.campaign.png",
                "organizationid": "1a3270bd-93cd-468e-8eba-b798b9158841",
                "totalpoints": 20,
                "splashheader": "Vinn fröpåse från Impecta Fröhandel!",
                "splashtext": "Samla 20 fröer under perioden april-maj, så kommer du belönas med en fröpåse!",
                "rewardheader": "Grattis!",
                "rewardtext": "Du har samlat 5 solar och har därmed förtjäntat en present från Impecta Fröhandel!",
                "rewarddescription": "Inom närmsta minuterna bör du få ett mail med en presentkod som du kan lösa in hos impecta.se.",
                "label": "gamificationorganizationcampaign",
                "name": "Vinn med Impecta Fröhandel!",
                "id": null,
                "imageid": null,
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
            }, ...data])

        }

    }
}


const useGamificationAdsApi = () => {
    const getAll = async (): Promise<GamificationAdType[]> => {
        return await FetchHandler.getJson("/api/gamification/campaign");
    }
    const add = async (e: GamificationAdType): Promise<boolean> => {
        return await FetchHandler.postJson("/api/gamification/campaign", e);;
    }
    const update = async (e: GamificationAdType): Promise<boolean> => {
        return await FetchHandler.patchJson("/api/gamification/campaign/" + e.id, e);;
    }
    const remove = async (id: string): Promise<boolean> => {
        return await FetchHandler.delete("/api/gamification/campaign/" + id);;
    }
    return {
        getAll: getAll,
        add: add,
        update: update,
        remove: remove,
    }
}

export type GamificationAdType = {
    year?: number
    month?: number
    header?: string
    text?: string
    imageurl?: string
    //folllowed: boolean
    organizationid?: string
    totalpoints?: number
    // mypoints: number
    splashheader?: string
    splashtext?: string
    rewardheader?: string
    rewardtext?: string
    rewarddescription?: string
    label?: string
    name?: string
    id?: string
    imageid?: string
    sys_datecreated_utc_epoch?: number
    sys_datemodified_utc_epoch?: number
}
